import { WithId } from '@common/typescript/objects/WithId';
import { Nullable, Optional } from '@common/typescript/objects/Nullable';

import { DeliveryType } from '@app/objects/Pet';

export enum SystemDeliveryType
{
	Clinic = 0,
	Mail = 1,
	HomeDropOff = 2,
	Pickup = 3,
}

export function toName(type: Nullable<SystemDeliveryType>): string {
	switch (type) {
	case SystemDeliveryType.Clinic: return 'Clinic';
	case SystemDeliveryType.Mail: return 'Mail';
	case SystemDeliveryType.HomeDropOff: return 'Home drop off';
	case SystemDeliveryType.Pickup: return 'Pickup';

	default: return 'None';
	}
}

export interface DeliveryTypeEntity extends WithId {
	name: string;
	description: string;
	systemType: Nullable<SystemDeliveryType>;
	bridge?: Nullable<DeliveryBridge>;
}

/**
 * Bridge exists only for DeliveryTypeEntities converted from DeliveryType enums
 */
interface DeliveryBridge extends WithId {
	deliveryType: DeliveryType;
	entityId: number;
}

/**
 * Convert DeliveryTypeEntity to DeliveryType (if conversion is possible)
 * @param {Nullable<DeliveryTypeEntity>} entity entity to be converted
 * @returns {DeliveryType} resulting DeliveryType enum
 */
export function toDeliveryType(entity: Optional<DeliveryTypeEntity>): DeliveryType {
	if (!entity) return DeliveryType.None;
	if (entity.bridge) return entity.bridge.deliveryType;

	switch (entity.systemType) {
	case SystemDeliveryType.Clinic: return DeliveryType.Clinic;
	case SystemDeliveryType.Mail: return DeliveryType.Mail;
	case SystemDeliveryType.HomeDropOff: return DeliveryType.HomeDropOff;

	default: return DeliveryType.None;
	}
}

export function toSystemType(type: DeliveryType): Nullable<SystemDeliveryType> {
	switch (type) {
	case DeliveryType.Clinic: return SystemDeliveryType.Clinic;
	case DeliveryType.Mail: return SystemDeliveryType.Mail;
	case DeliveryType.HomeDropOff: return SystemDeliveryType.HomeDropOff;

	default: return null;
	}
}
